import { render } from "./homehome.vue?vue&type=template&id=bcbf3c8a&scoped=true&ts=true"
import script from "./homehome.vue?vue&type=script&lang=ts"
export * from "./homehome.vue?vue&type=script&lang=ts"

import "./homehome.vue?vue&type=style&index=0&id=bcbf3c8a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcbf3c8a"]])

export default __exports__